import { render } from "./AnnouncementDataTable.vue?vue&type=template&id=5e7e601c"
import script from "./AnnouncementDataTable.vue?vue&type=script&lang=js"
export * from "./AnnouncementDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__